import { render, staticRenderFns } from "./Share2.vue?vue&type=template&id=1474f4aa&scoped=true&"
import script from "./Share2.vue?vue&type=script&lang=js&"
export * from "./Share2.vue?vue&type=script&lang=js&"
import style0 from "./Share2.vue?vue&type=style&index=0&id=1474f4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1474f4aa",
  null
  
)

export default component.exports